import React from 'react'
// import PropTypes from 'prop-types'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import { MainTitle, TextContent, JsonCodeStyle, Subtitle } from '../../../Shared';
import { StyledTableCell, StyledTableRow, useTableStyles } from '../../styles/Table.styled';
import {
  StyledSeparated,
} from './ResponseDefinition.styled';

function createData(code, message, detail) {
  return { code, message, detail };
}

const listResponseCode = [
  createData(200, 'SUCCESS', 'Perform task success'),
  createData(400, 'BAD REQUEST', 'Bad input parameter.'),
  createData(401, 'UNAUTHORIZED', 'The client passed in the invalid Auth token.'),
  createData(404, 'NOT FOUND', 'Url doest not exist'),
  createData(409, 'CONFLICT', 'Try to create a exist resource'),
  createData(500, 'INTERNAL SERVER ERROR', 'Server are not working as expected. The request is probably valid but need to be requested again later'),
  createData(503, 'SERVICE ERROR', 'Service unavailable'),
];

const listReasonType = [
  createData('required', 'Missing parameter', 'The parameters are missing'),
  createData('invalid', 'Invalid format', 'The field has invalid format'),
  createData('incorrect', 'Incorrect', 'The field has valid format but this value is incorrect'),
  createData('duplicated', 'Duplicate', 'The field has valid format but this value is duplicated'),
];

const ResponseDefinition = props => {
  const classes = useTableStyles();

  const APIStructure = {
    "code": 'xxx', //status code
    "message":"Human-readable message",//status message,developer can read this message for debugging
    "data":{}, //or [] , exists when response success
    "errors":[], // exists when response failure
    "debugError": {} //more human-readable info for fix bug purpose
  }

  const ErrorResponseStructure = {
    "code":"4xx",
    "message":"Error message",
    "errors":
    [
        {
            "domain":"field_1",
            "reason": "required",
            "message":"Field_1 existed",
        },
        {
            "domain":"field_2",
            "reason":"invalid",
            "message":"The field is missing or has invalid format"
        }
    ]
  }

  return (
    <div>
      <MainTitle>Response Definition</MainTitle>
      <TextContent>The response of each API have the same structure:</TextContent>
      <JsonCodeStyle data={APIStructure} />
      <Subtitle id="response-code">Response code</Subtitle>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Code</StyledTableCell>
              <StyledTableCell align="left">Message</StyledTableCell>
              <StyledTableCell align="left">Detail</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listResponseCode.map((row) => (
              <StyledTableRow key={row.code}>
                <StyledTableCell>
                  {row.code}
                </StyledTableCell>
                <StyledTableCell align="left">{row.message}</StyledTableCell>
                <StyledTableCell component="th" scope="row" align="left">{row.detail}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Subtitle id="error-detail">Error detail</Subtitle>
      <Subtitle isSmall id="error-response-structure">Error response structure</Subtitle>
      <JsonCodeStyle data={ErrorResponseStructure} />

      <Subtitle isSmall id="reason-type">Reason type</Subtitle>

      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Reason</StyledTableCell>
              <StyledTableCell align="left">Message</StyledTableCell>
              <StyledTableCell align="left">Detail</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listReasonType.map((row) => (
              <StyledTableRow key={row.code}>
                <StyledTableCell>
                  {row.code}
                </StyledTableCell>
                <StyledTableCell align="left">{row.message}</StyledTableCell>
                <StyledTableCell component="th" scope="row" align="left">{row.detail}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <StyledSeparated />
    </div>
  )
}

ResponseDefinition.propTypes = {

}

export default ResponseDefinition
